export enum BookingEarlyCheckInStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
}
